var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 40,
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.083 31.458v-2.125H10.5V16.75q0-3.417 2.083-6.042Q14.667 8.083 18 7.375V6.208q0-.833.583-1.396.584-.562 1.417-.562.833 0 1.417.562.583.563.583 1.396v1.167q3.333.708 5.438 3.333 2.104 2.625 2.104 6.042v12.583h3.375v2.125Zm12.917-12Zm0 16.875q-1.208 0-2.104-.875Q17 34.583 17 33.333h6q0 1.25-.875 2.125T20 36.333Zm-7.417-7h14.834V16.75q0-3.125-2.146-5.292Q23.125 9.292 20 9.292q-3.083 0-5.25 2.166-2.167 2.167-2.167 5.292Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotification);
export default __webpack_public_path__ + "static/media/icon-notification.8e8a1f0ed4ebb068acb4d8fddfe870da.svg";
export { ForwardRef as ReactComponent };